import { Navigate, useParams } from 'react-router-dom'
import { loiDashboardPath } from '@/features/campaigns/lib/loiDashboardNavigation'
import {
  instrumentDashboardPath,
  questionDrillDownPath,
} from '@/features/campaigns/lib/instrumentDashboardNavigation'

export function RedirectLegacyLoiDashboard() {
  const { loiId = '' } = useParams<{ loiId: string }>()
  return <Navigate to={loiDashboardPath(loiId)} replace />
}

export function RedirectLegacyInstrumentDashboard() {
  const { instrumentId = '' } = useParams<{ instrumentId: string }>()
  return <Navigate to={instrumentDashboardPath(instrumentId)} replace />
}

export function RedirectLegacyQuestionDrillDown() {
  const { instrumentId = '', questionId = '' } = useParams<{
    instrumentId: string
    questionId: string
  }>()
  return <Navigate to={questionDrillDownPath(instrumentId, questionId)} replace />
}
